<template>
  <div class="og-content-with-sidebar og-content-with-sidebar--search-result">
    <div class="grid-container">
      <div class="grid-x grid-padding-x align-center">
        <div class="cell medium-12 large-3 small-order-2 large-order-1">
          <course-to-course-search-filters-component
            :nonce="nonce"
            :shieldCheckIcon="shieldCheckIcon"
            :apiUrls="apiUrls"
            ref="searchFiltersComponentRef"
            is-on-results-page="true"
            base-page-path="/transfer-options/search-courses/"
            results-page-path="/transfer-options/search-courses/search-course-result/"
            @onSubmit="submit"
          ></course-to-course-search-filters-component>
        </div>

        <div class="cell medium-12 large-9 small-order-1 large-order-2">
          Search Result
          <div class="s-content-block s-content-block--small">
            <div class="o-form o-form--course-search" action="">
              <div class="o-search-results">
                <div class="o-search-results__header s-content-block s-content-block--small">
                  <div class="o-search-results__title">
                    <h3>Course to Course</h3>
                    <div class="o-search-results__button">
                      <form id="save-to-pdf-form" target="_blank" method="POST"></form>
                      <button
                        type="button"
                        class="a-button a-button--small a-button--primary-outline"
                        @click="downloadPdf"
                      >
                        Save to PDF
                      </button>
                      <button type="button" class="a-button a-button--small" @click="newSearch">
                        New Search
                      </button>
                    </div>
                  </div>
                  <p v-if="searchResponse.courses != null && searchResponse.courseDetail">
                    Showing result
                    <span v-if="fromOrToInstitution === 'from'">
                      <strong>FROM</strong>
                      {{ formattedCourseDetail }}
                    </span>
                    <span v-else>
                      <strong>TO</strong>
                      {{ formattedCourseDetail }}
                    </span>
                  </p>
                  <div class="m-selected-items">
                    <div class="a-selected-item" v-for="course in selectedCourses" :key="course.id">
                      <span v-if="course.courseYear == '1999'"
                        >{{ course.institutionCode }} {{ course.subjectCode }}
                        {{ course.courseNumber }} - 1995-1999
                        <span class="fa fa-close" @click="removeCourseTag(course)"></span
                      ></span>
                      <span v-else-if="course.courseYear == '2005'"
                        >{{ course.institutionCode }} {{ course.subjectCode }}
                        {{ course.courseNumber }} - 2000-2005
                        <span class="fa fa-close" @click="removeCourseTag(course)"></span
                      ></span>
                      <span v-else-if="course.courseYear == '2010'"
                        >{{ course.institutionCode }} {{ course.subjectCode }}
                        {{ course.courseNumber }} - 2006-2010
                        <span class="fa fa-close" @click="removeCourseTag(course)"></span
                      ></span>
                      <span v-else-if="course.courseYear == null"
                        >{{ course.institutionCode }} {{ course.subjectCode }}
                        {{ course.courseNumber }} - (1995 onwards)<span
                          class="fa fa-close"
                          @click="removeCourseTag(course)"
                        ></span
                      ></span>
                      <span v-else
                        >{{ course.institutionCode }} {{ course.subjectCode }}
                        {{ course.courseNumber }} -
                        {{ course.courseYear + '/' + _.toString(course.courseYear + 1).slice(-2) }}
                        <span class="fa fa-close" @click="removeCourseTag(course)"></span
                      ></span>
                    </div>
                  </div>
                </div>
                <div class="s-content-block s-content-block--small">
                  <h6 v-if="searchResponse.courses == null">
                    Use the Course To Course search to find out if you will receive transfer credit
                    for a course you have taken or want to take.
                  </h6>
                  <div v-else-if="_.get(searchResponse, 'courses.length') > 0">
                    <div class="o-search-result__table-total-page">
                      <div class="text-center medium-text-left">
                        {{ pageFrom }} to {{ pageTo }} of {{ totalAgreements }} matches <br />
                      </div>
                      <ul class="pagination" v-if="totalPages > 1">
                        <li
                          :class="['page-item', { disabled: currentPage === 1 }]"
                          :disabled="currentPage === 1"
                        >
                          <button
                            :class="['page-link', { disabled: currentPage === 1 }]"
                            :disabled="currentPage === 1"
                            @click="goToFirstPage"
                          >
                            First
                          </button>
                        </li>
                        <paginate
                          v-model="currentPage"
                          :page-count="totalPages"
                          :prev-text="'Previous'"
                          :next-text="'Next'"
                          :container-class="'pagination'"
                        >
                          <template #page="{ page, selected, disabled }">
                            <li :class="{ selected: selected }">
                              <button :disabled="disabled" @click="pageClick(page)">
                                {{ page }}
                              </button>
                            </li>
                          </template>
                        </paginate>
                        <li
                          :class="['page-item', { disabled: currentPage === totalPages }]"
                          :disabled="currentPage === totalPages"
                        >
                          <button
                            :class="['page-link', { disabled: currentPage === totalPages }]"
                            :disabled="currentPage === totalPages"
                            @click="goToLastPage"
                          >
                            Last
                          </button>
                        </li>
                      </ul>
                    </div>

                    <div class="o-search-results__table-wrapper">
                      <div>
                        <div class="o-search-results__table">
                          <div class="o-search-results__table-header course-to-course">
                            <div class="grid-x">
                              <div class="cell small-3">
                                <strong>From</strong>
                              </div>
                              <div class="cell small-9 cell-no-padding">
                                <div class="grid-x">
                                  <div class="cell small-3">
                                    <strong>To</strong>
                                  </div>

                                  <div class="cell small-6">
                                    <strong>Transfer Credit</strong>
                                  </div>

                                  <div class="cell small-3" style="display: block">
                                    <strong>Effective Date</strong>

                                    <span
                                      class="c2c-tooltip has-tip tip-left tip-bottom"
                                      data-tooltip="A transfer agreement applies when you have taken the course within the effective date period."
                                      >i</span
                                    >
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="o-search-results__table-row course-to-course">
                            <div
                              class="grid-x"
                              v-for="course in searchResponse.courses"
                              :key="`${course.sndrInstitutionCode} ${course.sndrSubjectCode} ${course.sndrCourseNumber} ${course.sndrCourseCredit}`"
                            >
                              <div class="cell small-3">
                                <div class="flex-container">
                                  <div class="o-search-results__logo sndr">
                                    <img
                                      v-if="course.sndrCountryId === 40"
                                      :src="`${logosUrl}/${course.sndrGlobalInstitutionID}_icon.png`"
                                    />
                                    <img
                                      v-else
                                      :src="`${logosUrl}/flags/${course.sndrCountryId}.png`"
                                    />
                                  </div>
                                  <span>
                                    {{ course.sndrInstitutionCode }}
                                    {{ course.sndrSubjectCode }}
                                    {{ course.sndrCourseNumber }}
                                  </span>
                                </div>
                                <p v-if="course.sndrCourseTitle">
                                  {{ course.sndrCourseTitle }}
                                </p>
                                <p v-if="course.sndrCourseCredit">
                                  Credits:
                                  {{ course.sndrCourseCredit }}
                                </p>
                                <p
                                  style="position: relative"
                                  v-bind="
                                    course.sndrIsMember
                                      ? { 'data-tooltip': 'BC Transfer System Member' }
                                      : {}
                                  "
                                >
                                  <img
                                    v-if="course.sndrIsMember"
                                    :src="shieldCheckIcon"
                                    width="14"
                                    height="14"
                                    style="margin-right: 5px"
                                  />{{ getInstitutionFullNameAndProvince(course) }}
                                </p>
                              </div>
                              <div class="cell small-9 cell-no-padding">
                                <div
                                  class="grid-x"
                                  v-for="agreement in course.agreements"
                                  :key="agreement.id"
                                >
                                  <div class="cell small-3">
                                    <div class="flex-container">
                                      <div
                                        class="o-search-results__logo recv"
                                        :data-tooltip="agreement.rcvrInstitutionName"
                                      >
                                        <img
                                          v-if="agreement.rcvrCountryId === 40"
                                          :src="`${logosUrl}/${agreement.rcvrGlobalInstitutionID}_icon.png`"
                                        />
                                        <img
                                          v-else
                                          :src="`${logosUrl}/flags/${agreement.rcvrCountryId}.png`"
                                        />
                                      </div>
                                      <span>{{ agreement.rcvrInstitutionCode }}</span>
                                    </div>
                                  </div>

                                  <div class="cell small-6">
                                    {{ agreement.detail
                                    }}{{ agreement.condition ? `, ${agreement.condition}` : '' }}
                                  </div>

                                  <div class="cell small-3">
                                    {{ agreementFromToDates(agreement) }}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="o-search-result__table-page">
                      <ul class="pagination" v-if="totalPages > 1">
                        <li
                          :class="['page-item', { disabled: currentPage === 1 }]"
                          :disabled="currentPage === 1"
                        >
                          <button
                            :class="['page-link', { disabled: currentPage === 1 }]"
                            :disabled="currentPage === 1"
                            @click="goToFirstPage"
                          >
                            First
                          </button>
                        </li>
                        <paginate
                          v-model="currentPage"
                          :page-count="totalPages"
                          :prev-text="'Previous'"
                          :next-text="'Next'"
                          :container-class="'pagination'"
                        >
                          <template #page="{ page, selected, disabled }">
                            <li :class="{ selected: selected }">
                              <button :disabled="disabled" @click="pageClick(page)">
                                {{ page }}
                              </button>
                            </li>
                          </template>
                        </paginate>
                        <li
                          :class="['page-item', { disabled: currentPage === totalPages }]"
                          :disabled="currentPage === totalPages"
                        >
                          <button
                            :class="['page-link', { disabled: currentPage === totalPages }]"
                            :disabled="currentPage === totalPages"
                            @click="goToLastPage"
                          >
                            Last
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <h6 v-else-if="_.get(searchResponse, 'courses.length') == 0">
                    There are no transfer agreements for that search. Please try again.
                  </h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, watch, computed } from 'vue'
import axios from 'axios'
import _ from 'lodash'
import Paginate from 'vuejs-paginate-next'
import CourseToCourseSearchFiltersComponent from './CourseToCourseSearchFiltersComponent.vue'

const props = defineProps({
  nonce: { required: true },
  logosUrl: { required: true },
  shieldCheckIcon: { required: true },
  apiUrls: {
    type: Object,
    required: true,
  },
})

const searchFiltersComponentRef = ref(null)
const searchResponse = ref({ courses: null })
const searchRequestCancelToken = ref(null)
const pdfRequestCancelToken = ref(null)
const pageLength = ref(null)
const pageFrom = ref(null)
const pageTo = ref(null)
const currentPage = ref(1)
const totalPages = ref(0)
const totalAgreements = ref(0)
const currentFilterData = ref({})
const fromOrToInstitution = ref('')
const anySelectedSubject = ref(false)
const searchDirection = ref('')
const selectedCourses = ref([])

const formattedCourseDetail = computed(() => {
  const detail = searchResponse.value.courseDetail || ''

  return detail
})

const goToFirstPage = () => {
  currentPage.value = 1
}

const goToLastPage = () => {
  currentPage.value = totalPages.value
}

watch(currentPage, (newCurrentPage, old) => {
  if (newCurrentPage === old) return
  if (newCurrentPage === 1 && old === null) return
  const data = _.clone(currentFilterData.value)
  _.set(data, 'pageNumber', newCurrentPage)
  submit(data)
})

function homePageToCourseToCourse(fromTo) {
  let searchParams = new URLSearchParams()
  searchParams.set('fromTo', fromTo)

  window.location.href = props.filtersPagePath + '?' + searchParams.toString()
}

function getInstitutionFullNameAndProvince(institution, type = 'sndr') {
  const name = _.get(institution, `${type}InstitutionName`)
  const country = _.get(institution, `${type}Country`)
  const countryShortName = _.get(institution, `${type}CountryShortName`)
  const province = _.get(institution, `${type}Province`)
  let label = `${name}`
  if (['Canada', 'United States of America'].includes(country) && province) {
    label = `${label} (${province})`
  } else if (countryShortName) {
    label = `${label} (${countryShortName})`
  } else if (country) {
    label = `${label} (${country})`
  }
  return label
}

function removeCourseTag(course) {
  searchFiltersComponentRef.value.removeInstitutionTag(course)
}

function submit(data) {
  currentFilterData.value = _.clone(data)
  fromOrToInstitution.value = data.fromOrToInstitution
  anySelectedSubject.value = data.first.subject && data.first.subject.id == 0 ? true : false
  delete data.fromOrToInstitution
  switch (fromOrToInstitution.value) {
    case 'from':
      if (_.get(data, 'first.selectedCourses.length') > 0) {
        searchFromCourseLoad(data)
      } else {
        searchFrom(data)
      }
      break
    case 'to':
      if (_.get(data, 'first.selectedCourses.length') > 0) {
        searchToCourseLoad(data)
      } else {
        searchTo(data)
      }
      break
  }
}

const downloadPdf = (event) => {
  event.preventDefault()
  const data = searchFiltersComponentRef.value.getSubmitData()
  currentFilterData.value = _.clone(data)
  fromOrToInstitution.value = data.fromOrToInstitution
  anySelectedSubject.value = data.first.subject && data.first.subject.id === 0 ? true : false
  delete data.fromOrToInstitution
  switch (fromOrToInstitution.value) {
    case 'from':
      if (_.get(data, 'first.selectedCourses.length') > 0) {
        searchFromCourseLoad(data, true)
      } else {
        searchFrom(data, true)
      }
      break
    case 'to':
      if (_.get(data, 'first.selectedCourses.length') > 0) {
        searchToCourseLoad(data, true)
      } else {
        searchTo(data, true)
      }
      break
  }
}

function pdfRequestHandler(data, path, params) {
  const saveToPdfFormElement = document.getElementById('save-to-pdf-form')
  saveToPdfFormElement.action = `${path}?_wpnonce=${props.nonce}`
  saveToPdfFormElement.innerHTML = ''
  _.forEach(params, (paramValue, paramName) => {
    if (paramName === 'courseLoads' && _.isArray(paramValue)) {
      paramValue.forEach((courseLoad) => {
        const newInput = document.createElement('input')
        newInput.type = 'hidden'
        newInput.name = `${paramName}[]`
        newInput.value = courseLoad
        saveToPdfFormElement.append(newInput)
      })
      return
    }
    const newInput = document.createElement('input')
    newInput.type = 'hidden'
    newInput.id = paramName
    newInput.name = paramName
    newInput.value = paramValue
    saveToPdfFormElement.append(newInput)
  })
  saveToPdfFormElement.submit()
}

function searchRequestHandler(data, path, params) {
  if (searchRequestCancelToken.value) {
    searchRequestCancelToken.value.cancel()
  }
  document.body.classList.add('js-is-searching')
  $('html, body').animate({ scrollTop: $('.js-header').offset().top + 200 }, '400')
  searchRequestCancelToken.value = axios.CancelToken.source()
  searchResponse.value.courses = null
  axios
    .post(`${path}?_wpnonce=${props.nonce}`, params, {
      cancelToken: searchRequestCancelToken.value.token,
    })
    .then((response) => {
      searchResponseHandler(response, data)
    })
}

const searchResponseHandler = (response) => {
  Object.assign(searchResponse.value, response.data)

  if (!response.data.courseDetail) {
    searchResponse.value.courseDetail = null
  }

  document.body.classList.remove('js-is-searching')

  const attributes = {
    currentPage,
    totalPages,
    totalAgreements,
    pageLength,
    pageFrom,
    pageTo,
  }

  Object.keys(attributes).forEach((key) => {
    const value = _.get(searchResponse.value, key)
    if (value !== attributes[key].value) {
      attributes[key].value = value
    }
  })
}

function searchFrom(data, pdf = false) {
  let params = {}
  _.forEach(
    {
      sender: 'first.institution.id',
      institutionCode: 'first.institution.code',
      subjectId: 'first.subject.id',
      subjectCode: 'first.subject.code',
      courseNumber: 'first.courseNumber',
      year: 'first.year',
      pageNumber: 'pageNumber',
    },
    (dotNotation, valueName) => {
      let value = _.get(data, dotNotation)
      if (value) {
        _.set(params, valueName, value)
      }
    },
  )
  let receivers = _.map(_.get(data, 'second.institutions', []), (institution) =>
    _.get(institution, 'id'),
  ).join()
  if (receivers) {
    _.set(params, 'receivers', receivers)
  }
  let institutionTypes = _.map(_.get(data, 'second.institutionTypes', []), (instType) =>
    _.get(instType, 'id'),
  ).join()
  if (institutionTypes) {
    _.set(params, 'instTypes', institutionTypes)
  }
  let isPrivate = _.get(data, 'second.isPrivate')
  if (isPrivate) {
    _.set(params, 'isPublic', false)
  } else {
    _.set(params, 'isPublic', null)
  }
  let isMember = _.get(data, 'first.institution.isMember')
  _.set(params, 'isMember', isMember)
  if (pdf) {
    pdfRequestHandler(data, '/wp-json/bctg-search/course-to-course/search-from/pdf', params)
    return
  }
  searchRequestHandler(data, '/wp-json/bctg-search/course-to-course/search-from', params)
}

function searchTo(data, pdf = false) {
  let params = {}
  _.forEach(
    {
      receiver: 'first.institution.id',
      institutionCode: 'first.institution.code',
      subjectId: 'first.subject.id',
      subjectCode: 'first.subject.code',
      courseNumber: 'first.courseNumber',
      year: 'first.year',
      pageNumber: 'pageNumber',
    },
    (dotNotation, valueName) => {
      let value = _.get(data, dotNotation)
      if (value) {
        _.set(params, valueName, value)
      }
    },
  )
  let senders = _.map(_.get(data, 'second.institutions', []), (institution) =>
    _.get(institution, 'id'),
  ).join()
  if (senders) {
    _.set(params, 'senders', senders)
  }
  let institutionTypes = _.map(_.get(data, 'second.institutionTypes', []), (instType) =>
    _.get(instType, 'id'),
  ).join()
  if (institutionTypes) {
    _.set(params, 'instTypes', institutionTypes)
  }
  let isPrivate = _.get(data, 'second.isPrivate')
  if (isPrivate) {
    _.set(params, 'isPublic', false)
  } else {
    _.set(params, 'isPublic', null)
  }
  let senderCountryId = _.get(data, 'second.country.id')
  if (senderCountryId) {
    _.set(params, 'senderCountryId', senderCountryId)
  }
  if (pdf) {
    pdfRequestHandler(data, '/wp-json/bctg-search/course-to-course/search-to/pdf', params)
    return
  }
  searchRequestHandler(data, '/wp-json/bctg-search/course-to-course/search-to', params)
}

function generateCourseLoadsData(data) {
  return _.get(data, 'first.selectedCourses', []).map((course) => {
    let value = `${course.institutionId} ${course.subjectId} ${course.courseNumber}`
    if (course.courseYear) {
      value = `${value} ${course.courseYear}`
    } else {
      value = `${value} null`
    }
    return value
  })
}

function searchFromCourseLoad(data, pdf = false) {
  const institutionCode = _.get(data, 'first.institution.code')
  const subjectCode = _.get(data, 'first.subject.code')
  const courseNumber = _.get(data, 'first.courseNumber')
  const searchTerm = `${institutionCode} ${subjectCode} ${courseNumber}`
  let params = {
    pageNumber: _.get(data, 'pageNumber'),
    searchTerm: searchTerm,
  }
  const courseLoads = generateCourseLoadsData(data)
  if (courseLoads) {
    _.set(params, 'courseLoads', courseLoads)
  }
  let receivers = _.map(_.get(data, 'second.institutions', []), (institution) =>
    _.get(institution, 'id'),
  ).join()
  if (receivers) {
    _.set(params, 'receivers', receivers)
  }
  let institutionTypes = _.map(_.get(data, 'second.institutionTypes', []), (instType) =>
    _.get(instType, 'id'),
  ).join()
  if (institutionTypes) {
    _.set(params, 'instTypes', institutionTypes)
  }
  let isPrivate = _.get(data, 'second.isPrivate')
  if (isPrivate) {
    _.set(params, 'isPublic', false)
  } else {
    _.set(params, 'isPublic', null)
  }
  if (pdf) {
    pdfRequestHandler(
      data,
      '/wp-json/bctg-search/course-to-course/search-from-course-load/pdf',
      params,
    )
    return
  }
  searchRequestHandler(
    data,
    '/wp-json/bctg-search/course-to-course/search-from-course-load',
    params,
  )
}

function searchToCourseLoad(data, pdf = false) {
  const institutionCode = _.get(data, 'first.institution.code')
  const subjectCode = _.get(data, 'first.subject.code')
  const courseNumber = _.get(data, 'first.courseNumber')
  const searchTerm = `${institutionCode} ${subjectCode} ${courseNumber}`
  let params = {
    pageNumber: _.get(data, 'pageNumber'),
    searchTerm: searchTerm,
  }
  const courseLoads = generateCourseLoadsData(data)
  if (courseLoads) {
    _.set(params, 'courseLoads', courseLoads)
  }
  let senders = _.map(_.get(data, 'second.institutions', []), (institution) =>
    _.get(institution, 'id'),
  ).join()
  if (senders) {
    _.set(params, 'senders', senders)
  }
  let institutionTypes = _.map(_.get(data, 'second.institutionTypes', []), (instType) =>
    _.get(instType, 'id'),
  ).join()
  if (institutionTypes) {
    _.set(params, 'instTypes', institutionTypes)
  }
  let isPrivate = _.get(data, 'second.isPrivate')
  if (isPrivate) {
    _.set(params, 'isPublic', false)
  } else {
    _.set(params, 'isPublic', null)
  }
  let senderCountryId = _.get(data, 'second.country.id')
  if (senderCountryId) {
    _.set(params, 'senderCountryId', senderCountryId)
  }
  if (pdf) {
    pdfRequestHandler(
      data,
      '/wp-json/bctg-search/course-to-course/search-to-course-load/pdf',
      params,
    )
    return
  }
  searchRequestHandler(data, '/wp-json/bctg-search/course-to-course/search-to-course-load', params)
}

const agreementFromToDates = (agreement) => {
  const dateFormat = { year: '2-digit', month: 'short' }

  const formatDate = (dateString) => {
    const date = new Date(dateString.slice(0, 4), dateString.slice(4, 6) - 1, 1)
    const formattedDate = new Intl.DateTimeFormat('en-US', dateFormat).format(date)
    return formattedDate.replace(' ', '/')
  }

  let startDate = _.get(agreement, 'startDate')
  if (startDate) {
    startDate = formatDate(startDate)
  }

  let endDate = _.get(agreement, 'endDate')
  if (endDate) {
    endDate = formatDate(endDate)
  }

  if (startDate && endDate) {
    return `${startDate} to ${endDate}`
  }

  if (startDate) {
    return `${startDate} ongoing`
  }

  return ''
}

function newSearch() {
  searchFiltersComponentRef.value.newSearch()
}
</script>

<style>
.c2c-add-course-tooltip,
div.c2c-add-course-tooltip[data-tooltip] {
  margin-right: 8px !important;
  cursor: pointer;
  position: relative !important;
}
</style>
